import { memo } from "react";
import { WorkPermitApprover } from "../../constants/common";
import { formattedDateTimeWithoutSec } from "../../lib/functions";

interface PermitApproversProps {
  sectionNumber: number;
  approvers: WorkPermitApprover[];
}

const PermitApprovers = ({ sectionNumber, approvers, }: PermitApproversProps) => {
  return (
    <div>
      <div className="bg-green-primary text-center border-t border-black py-0.5">
        <span className="text-[10px] text-white font-bold">
          Section {sectionNumber}: Approval
        </span>
      </div>

      <table className="w-full text-xs">
        <thead>
          <tr className="bg-gray-300">
            <th className="border-y-[0.2px] border-black p-1 text-[10px] h-4">
              Approvers
            </th>
            <th className="border-y-[0.2px] border-l-[0.2px] border-black p-1 text-[10px] h-4">
              Date
            </th>
            <th className="border-[0.2px] border-black p-1 text-[10px] h-4">
              Name
            </th>
            <th className="border-y-[0.2px] border-r-[0.2px] border-black p-1 text-[10px] h-4">
              Sign
            </th>
            <th className="border-y-[0.2px] border-black p-1 text-[10px] h-4">
              Comments
            </th>
          </tr>
        </thead>
        <tbody>
          {approvers?.map((row, idx) => (
            <tr key={idx}>
              <td className="border-b-[0.2px] border-r-[0.2px] border-black p-2 h-6 text-[10px] text-center">
                {row.approverRole}
              </td>
              <td className="border-b-[0.2px] border-r-[0.2px] border-black p-2 h-6 text-[10px] text-center">
                {formattedDateTimeWithoutSec(row.dt_ApprovalDate)}
              </td>
              <td className="border-b-[0.2px] border-r-[0.2px] border-black p-2 h-6 text-[10px] text-center">
                {row.approverName}
              </td>
              <td className="border-b-[0.2px] border-r-[0.2px] border-black p-2 h-6 text-[10px] text-center">
                {row?.uploadSignatureContentType ? (
                  <div className="flex items-center justify-center h-[20px] max-w-max mx-auto">
                    <img
                      src={`data:${row?.uploadSignatureContentType};base64,${row?.uploadSignature}`}
                      alt="logo"
                      className="w-[100px] h-[20px] object-contain"
                    />
                  </div>
                ) : (
                  "N/A"
                )}
              </td>
              <td className="border-b-[0.2px] border-black p-2 h-6 text-[10px] text-center">
                {row.comments}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default memo(PermitApprovers);
